import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { ngListService } from '../../../list/core/ng-list.service';
import { ListHierarchy } from '../../../list/shared/list-hierarchy';

@Directive({
  selector: '[rlHierarchy]'
})
export class HierarchyDirective implements OnInit {
    
  @Input('rlHierarchy') hierarchy : ListHierarchy[];

  constructor(private template: TemplateRef<any>, private container: ViewContainerRef ,private listService : ngListService) {}
    
    ngOnInit() { 
        if(!this.hierarchy || this.hierarchy.length == 0){
          return;
      }

      for (let index = 0; index < this.hierarchy.length; index++) {
        const element = this.hierarchy[index];
          if(this.listService.currentList && this.listService.currentList.hierarchy == element){
            this.container.createEmbeddedView(this.template);
            return;
          }
      }
      this.container.clear();
    }

}
